import type { Shape } from '~/types/grid.types'
import { SHAPE_IDS } from './shapesIdsSquare'

export const ENGRAVED_2X2_SQUARE_SHAPES: Shape[] = [
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_TANGENT,
    icon: 'EngravedTangent',
    prefix: 'Tangent',
    label: 'Tangent',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TANGENT_90,
        icon: 'EngravedTangent',
        prefix: 'Tangent',
        label: 'Tangent 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TANGENT_180,
        icon: 'EngravedTangent',
        prefix: 'Tangent',
        label: 'Tangent 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TANGENT_270,
        icon: 'EngravedTangent',
        prefix: 'Tangent',
        label: 'Tangent 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: 'EngravedConverge',
    icon: 'EngravedConverge',
    prefix: 'Converge',
    label: 'Converge',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_CONVERGE_90,
        icon: 'EngravedConverge',
        prefix: 'Converge',
        label: 'Converge 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_CONVERGE_180,
        icon: 'EngravedConverge',
        prefix: 'Converge',
        label: 'Converge 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_CONVERGE_270,
        icon: 'EngravedConverge',
        prefix: 'Converge',
        label: 'Converge 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_OFFSET,
    icon: 'EngravedOffset',
    prefix: 'Offset',
    label: 'Offset',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_OFFSET_90,
        icon: 'EngravedOffset',
        prefix: 'Offset',
        label: 'Offset 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_OFFSET_180,
        icon: 'EngravedOffset',
        prefix: 'Offset',
        label: 'Offset 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_OFFSET_270,
        icon: 'EngravedOffset',
        prefix: 'Offset',
        label: 'Offset 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_TOPO,
    icon: 'EngravedTopo',
    prefix: 'Topo',
    label: 'Topo',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TOPO_90,
        icon: 'EngravedTopo',
        prefix: 'Topo',
        label: 'Topo 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TOPO_180,
        icon: 'EngravedTopo',
        prefix: 'Topo',
        label: 'Topo 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_TOPO_270,
        icon: 'EngravedTopo',
        prefix: 'Topo',
        label: 'Topo 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_LARGE_PARALLEL,
    icon: 'EngravedLargeParallel',
    prefix: 'LargeParallel',
    label: 'LargeParallel',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_LARGE_PARALLEL_90,
        icon: 'EngravedLargeParallel',
        prefix: 'LargeParallel',
        label: 'Large Parallel 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_RIVER,
    icon: 'EngravedRiver',
    prefix: 'River',
    label: 'River',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_RIVER_90,
        icon: 'EngravedRiver',
        prefix: 'River',
        label: 'River 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_SUBWAY,
    icon: 'EngravedSubway',
    prefix: 'Subway',
    label: 'Subway',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_SUBWAY_90,
        icon: 'EngravedSubway',
        prefix: 'Subway',
        label: 'Subway 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_SUBWAY_180,
        icon: 'EngravedSubway',
        prefix: 'Subway',
        label: 'Subway 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_SUBWAY_270,
        icon: 'EngravedSubway',
        prefix: 'Subway',
        label: 'Subway 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_ZEN,
    icon: 'EngravedZen',
    prefix: 'Zen',
    label: 'Zen',
    w: 240,
    h: 240,
    rotation: 0,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_ZEN_90,
        icon: 'EngravedZen',
        prefix: 'Zen',
        label: 'Zen 90',
        w: 240,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_ZEN_180,
        icon: 'EngravedZen',
        prefix: 'Zen',
        label: 'Zen 180',
        w: 240,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: SHAPE_IDS.ENGRAVED_ZEN_270,
        icon: 'EngravedZen',
        prefix: 'Zen',
        label: 'Zen 270',
        w: 240,
        h: 240,
        rotation: 270,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS.ENGRAVED_KNOT,
    icon: 'EngravedKnot',
    prefix: 'Knot',
    label: 'Knot',
    w: 240,
    h: 240,
    admin: true,
  },
]
